import React from "react"
import { withRouter } from "react-router"
import { Link } from "react-router-dom"
import { Modal } from "semantic-ui-react/"
import { getMyMedal } from "../../api/sync/races"
import { Loader } from "../../components/Loader"
import { endRegisterRace } from "../../utils"

class MyMedal extends React.Component {
  state = {
    loading: true,
    limit: this.props.limit || 3,
    medals: [],
    modalOpen: false,
    distance: "",
    name: "",
    raceTitle: "",
    pace: "",
    medal: ""
  }

  componentDidMount() {
    getMyMedal().then(res => {
      this.setState({ loading: false })
      this.setState({ medals: res.data.results })
    })
  }

  triggerMedal = medal => {
    if (!medal.is_joined) {
      this.props.history.push(`/races/${medal.id}`)
    } else if (medal.finish_run) {
      this.setState({ distance: medal.total_distance.toFixed(2).toString() })
      this.setState({ pace: medal.pace.toFixed(2).toString() })
      this.setState({ raceTitle: medal.title })
      this.setState({ name: medal.name })
      this.setState({ medal: medal.color_medal })
      this.setState({ modalOpen: true })
    }
  }

  render() {
    return this.state.loading ? (
      <Loader />
    ) : (
      <div style={{ textAlign: "center" }}>
        <h1>My Medals</h1>
        <div
          className="ui grid"
          style={{ width: "80%", margin: "0 auto", textAlign: "center" }}
        >
          <img
            className="top-frame mobile-mymedal-top-and-bottom"
            src="https://api.run24hrs.com/media/images/FrameHead801x90.png"
          />
          <div
            style={{
              backgroundImage:
                "url(https://api.run24hrs.com/media/images/FrameBody801x210_1.png)"
            }}
            className="two column row badge-box"
          >
            {this.state.medals
              .filter(each => each.black_white_medal)
              .map(each => (
                <div
                  className="column badge-wrapper"
                  // onClick={() => this.triggerMedal(each)}
                >
                  <Link to={`/races/${each.slug}`}>
                    <img
                      style={{ width: "60%" }}
                      src={
                        each.finish_run
                          ? each.color_medal
                          : each.black_white_medal
                      }
                    />
                  </Link>{" "}
                  {!each.finish_run && (
                    <p style={{ color: "black" }}>
                      {each.is_joined
                        ? "Joined"
                        : !endRegisterRace(each)
                        ? "Open"
                        : "Close"}
                    </p>
                  )}
                  {each.finish_run && (
                    <p style={{ color: "black" }}>Finished</p>
                  )}
                </div>
              ))}
          </div>
          <img
            style={{ marginTop: "-1px" }}
            className="bottom-frame mobile-mymedal-top-and-bottom"
            src="https://api.run24hrs.com/media/images/FrameBottom801x90.png"
          />
          <Modal
            open={this.state.modalOpen}
            closeIcon
            onClose={() => this.setState({ modalOpen: false })}
          >
            <Modal.Content image>
              <Modal.Description>
                <img
                  className="top-frame"
                  src="https://s3-ap-southeast-1.amazonaws.com/web42-assets/images/medals/top-frame.png"
                />
                <div className="column badge-wrapper badge-box">
                  {" "}
                  <img
                    style={{ maxWidth: "20%" }}
                    src={this.state.medal}
                  />{" "}
                  <h1 style={{ color: "white" }}>
                    Congratulations {this.state.name}
                  </h1>
                  <p>You Finished the {this.state.raceTitle}</p>
                  <div className="ui grid">
                    <div className="two column row">
                      <div className="column">
                        <h3 style={{ color: "white" }}>
                          {this.state.distance}
                        </h3>
                        <p>Distance</p>
                      </div>
                      <div className="column">
                        <h3 style={{ color: "white" }}>
                          {this.state.pace.replace(".", '"')}
                        </h3>
                        <p>Pace</p>
                      </div>
                    </div>
                  </div>
                </div>
                <img
                  className="bottom-frame"
                  src="https://s3-ap-southeast-1.amazonaws.com/web42-assets/images/medals/bottom-frame.png"
                />
              </Modal.Description>
            </Modal.Content>
          </Modal>
        </div>
      </div>
    )
  }
}
export default withRouter(MyMedal)



// WEBPACK FOOTER //
// /opt/build/repo/src/containers/MyMedal/index.js